import React from 'react';
import { ILandingPageProps } from '@interfaces';
import { ShipPosition } from '../components/sections/ship-position/ship-position';
import { LocaleConfigContext } from '../contexts/locale-config/locale-config';

export const ShipLivePositionMod = ({
    getLandingPage,
    modulesData,
}: ILandingPageProps['pageProps']) => {
    const localeConfig = React.useContext(LocaleConfigContext);
    const data = modulesData[`ship${getLandingPage.id}`];
    if (!data || !data.livePosition) {
        return null;
    }
    const { lastPort, latitude, longitude, speed, course, nextPort } = data.livePosition;
    return (
        <ShipPosition
            key="shipLivePosition"
            latitude={latitude}
            longitude={longitude}
            name={getLandingPage.title || ''}
            speed={`${speed}`}
            course={course}
            nextPort={nextPort}
            lastPort={lastPort}
            href={`/${getLandingPage.url}/${localeConfig.slugs.liveposition}`.replace('//', '/')}
        />
    );
};
